import { B_RealEstateFormCreateBody } from "@/src-refactor/modules/store/qrtk/services/realestate/values/create-realestate.value";
import prepareOwnersToServer from "./to-server/prepareOwnersToServer";
import { HGetValueFromArray } from "@rf-helper/get-value-from-array";
import prepareBudgetToServer from "./to-server/prepareBudgetToServer";
import prepareVideosToServer from "./to-server/prepareVideosToServer";
import prepareImagesToServer from "./to-server/prepareImagesToServer";
import prepareSeoToServer from "./to-server/prepareSeoToServer";
import prepareAlterEstateToServer from "./to-server/prepareAlterEstateToServer";
import prepareFeaturesToServer from "./to-server/prepareFeaturesToServer";
import prepareDocumentsToServer from "./to-server/prepareDocumentsToServer";
import prepareCaracteristicToServer from "./to-server/prepareCaracteristicToServer";
import HTransformObject from "@rf-helper/transform-object.helper";
import { IPropertyForm } from "../../components/property-form/util/schemas/property-schema/propertySchema";
import prepareMeterContrutionLandToServer from "./to-server/prepareMeterContrutionLandToServer";

const CreatePropertyAdapter: ICreatePropertyAdapter = (state: IPropertyForm) => {
  const budged = prepareBudgetToServer(state);
  const videos = prepareVideosToServer(state);
  const owners = prepareOwnersToServer(state);
  const images = prepareImagesToServer(state);
  const seo = prepareSeoToServer(state);
  const alterEstate = prepareAlterEstateToServer(state);
  const features = prepareFeaturesToServer(state);
  const documents = prepareDocumentsToServer(state);
  const caract = prepareCaracteristicToServer(state);
  const meters = prepareMeterContrutionLandToServer(state);

  const payloadDirty = {
    ...alterEstate,
    ...caract,
    ...meters,
    videos,
    images,
    info: seo,
    features: features,
    documents: documents,
    // location
    owners,
    latitude: state.latitude_property,
    longitude: state.longitude_property,
    sector_id: HGetValueFromArray(state.sector_property, "value"),
    city_id: HGetValueFromArray(state.city_property, "value"),
    address: state.address_property,
    reference: state.reference_point_property,
    //description
    realstatetype_id: HGetValueFromArray(state.type_property, "id"),
    name: state.name_property,
    ...budged,
    is_collection: HGetValueFromArray(state.is_collection_property, "id"),
    condition_status: HGetValueFromArray(state.condition_property, "id"),
    arrangement_id: HGetValueFromArray(state.arrangement_type_property, "id"),
    is_no_broker: HGetValueFromArray(state.associates_type_property, "id"),
    has_loan: HGetValueFromArray(state.have_mortgage_property, "id"),
    loan_note: state.notes_property,
    property_title_number: state.registration_number
      ? state.registration_number.toString()
      : "",
    realstate_tour_url: state.tour_virtual_property,
    visit: HGetValueFromArray(state.visit_type_property, "id"),
    visit_status: HGetValueFromArray(state.is_habited_property, "id"),
    brokers: state.brokers_property.map(x => x.value),

    dropbox_link: state.dropbox_link_property,
    google_drive_link: state.drive_link_property,

    maintenance_currency_id: HGetValueFromArray(
      state.currency_maintenance_property,
      "id"
    ),
    maintenance_fee: state.price_maintenance_property,
    tarea: state.tareas_property,
    draft_id: state.draft_id,
    // Aunque se usa en edición, lo enviamos siempre por consistencia
    remove_documents: state.remove_documents
  };

  return HTransformObject(payloadDirty, {
    removeUndefined: true,
    removeEmptyArray: true,
    removeNull: true,
    removeEmptyStrings: true,
    removeEmptyObjects: true
  });
};

type ICreatePropertyAdapter = (state: IPropertyForm) => B_RealEstateFormCreateBody;

export default CreatePropertyAdapter;
